var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('h1',[_vm._v("Página no encontrada")]),_c('p',[_vm._v("No existe ninguna ruta como la requerida: "+_vm._s(this.$route.path))]),_c('router-link',{attrs:{"to":{name: 'Dashboard'}}},[_c('b-button',{staticClass:"mt-4",attrs:{"variant":"primary"}},[_vm._v("Volver al Dashboard")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }